import React, { useEffect, useRef, useState } from "react";
import ManageOrderTableData from "./manageOrderTableData";
import { useDispatch } from "react-redux";
import { manageOrderList } from "../../redux/actions/manageOrderActions";
import DownArrow from "../../assets/filterArrowDown.svg";
import UpArrow from "../../assets/filterArrowUp.svg";
import "../products/productDetail.css";
import "./manageOrders.css";
import ErrorPopup from "../../components/popups/ErrorPopup";
import LoadingSpinnerTable from "../../components/utilites/loader";
import { useNavigate, useParams } from "react-router-dom";
import NumberPagination from "../../components/Pagination/number-pagination";

const ManageOrderTable = ({
  search,
  setInvStatus,
  invStatus,
  status,
  setStatus,
  order_date_from,
  order_date_to,
  order_value_from,
  order_value_to,
  setOrder_value_from,
  setOrder_value_to,
  setOrder_date_from,
  setOrder_date_to,
  page_no,
  filterStoredData,
}) => {
  const dispatch = useDispatch();
  const params = useParams();
  const navigate = useNavigate();
  const orderDateRef = useRef(null);
  const orderValueRef = useRef(null);
  const orderStatusRef = useRef(null);
  const invoiceStatusRef = useRef(null);
  const [openOrder, setOpenOrder] = useState(false);
  const [openDate, setOpenDate] = useState(false);
  const [manageOrderListData, setManageOrderListData] = useState([]);
  const [page, setPage] = useState(page_no ? page_no : 1);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [openStatus, setOpenStatus] = useState(false);
  const [filteredStatusOptions, setFilteredStatusOptions] = useState([]);
  const [openInvStatus, setOpenInvStatus] = useState(false);

  console.log(order_date_to, filterStoredData, "order_date_to");

  const OrderValueSubmit = () => {
    setOpenOrder(false);
    navigate(
      `/manage-order?page=1${search ? `&search=${search}` : ""}${
        filterStoredData?.invStatus
          ? `&invStatus=${filterStoredData?.invStatus}`
          : ""
      }${
        filterStoredData?.order_date_from
          ? `&order_date_from=${filterStoredData?.order_date_from}`
          : ""
      }${
        filterStoredData?.order_date_to
          ? `&order_date_to=${filterStoredData?.order_date_to}`
          : ""
      }${
        filterStoredData?.status ? `&status=${filterStoredData?.status}` : ""
      }&order_value_from=${
        order_value_from ?? ""
      }&order_value_to=${order_value_to}`
    );
  };

  const OrderDateSubmit = () => {
    setOpenDate(false);
    navigate(
      `/manage-order?page=1${search ? `&search=${search}` : ""}${
        filterStoredData?.invStatus
          ? `&invStatus=${filterStoredData?.invStatus}`
          : ""
      }${
        filterStoredData?.order_value_from
          ? `&order_value_from=${filterStoredData?.order_value_from}`
          : ""
      }${
        filterStoredData?.order_value_to
          ? `&order_value_to=${filterStoredData?.order_value_to}`
          : ""
      }${
        filterStoredData?.status ? `&status=${filterStoredData?.status}` : ""
      }&order_date_from=${order_date_from ?? ""}&order_date_to=${order_date_to}`
    );
  };

  const applyStatusFilter = () => {
    setFilteredStatusOptions([]);
    navigate(
      `/manage-order?page=1${search ? `&search=${search}` : ""}${
        filterStoredData?.invStatus
          ? `&invStatus=${filterStoredData?.invStatus}`
          : ""
      }${
        filterStoredData?.order_date_from
          ? `&order_date_from=${filterStoredData?.order_date_from}`
          : ""
      }${
        filterStoredData?.order_date_to
          ? `&order_date_to=${filterStoredData?.order_date_to}`
          : ""
      }${
        filterStoredData?.order_value_from
          ? `&order_value_from=${filterStoredData?.order_value_from}`
          : ""
      }${
        filterStoredData?.order_value_to
          ? `&order_value_to=${filterStoredData?.order_value_to}`
          : ""
      }&status=${status ?? []}`
    );
  };

  const orderValueClear = () => {
    setOrder_value_from(null);
    setOrder_value_to(null);
    setOpenOrder(false);
    navigate(
      `/manage-order?page=1${search ? `&search=${search}` : ""}${
        filterStoredData?.invStatus
          ? `&invStatus=${filterStoredData?.invStatus}`
          : ""
      }${
        filterStoredData?.order_date_from
          ? `&order_date_from=${filterStoredData?.order_date_from}`
          : ""
      }${
        filterStoredData?.order_date_to
          ? `&order_date_to=${filterStoredData?.order_date_to}`
          : ""
      }${filterStoredData?.status ? `&status=${filterStoredData?.status}` : ""}`
    );
  };

  const orderDateClear = () => {
    setOrder_date_from(null);
    setOrder_date_to(null);
    setOpenDate(false);
    navigate(
      `/manage-order?page=1${search ? `&search=${search}` : ""}${
        filterStoredData?.invStatus
          ? `&invStatus=${filterStoredData?.invStatus}`
          : ""
      }${
        filterStoredData?.order_value_from
          ? `&order_value_from=${filterStoredData?.order_value_from}`
          : ""
      }${
        filterStoredData?.order_value_to
          ? `&order_value_to=${filterStoredData?.order_value_to}`
          : ""
      }${filterStoredData?.status ? `&status=${filterStoredData?.status}` : ""}`
    );
  };

  const orderStatusClear = () => {
    navigate(
      `/manage-order?page=1${search ? `&search=${search}` : ""}${
        filterStoredData?.invStatus
          ? `&invStatus=${filterStoredData?.invStatus}`
          : ""
      }${
        filterStoredData?.order_value_from
          ? `&order_value_from=${filterStoredData?.order_value_from}`
          : ""
      }${
        filterStoredData?.order_value_to
          ? `&order_value_to=${filterStoredData?.order_value_to}`
          : ""
      }${
        filterStoredData?.order_date_from
          ? `&order_date_from=${filterStoredData?.order_date_from}`
          : ""
      }${
        filterStoredData?.order_date_to
          ? `&order_date_to=${filterStoredData?.order_date_to}`
          : ""
      }`
    );
  };

  useEffect(() => {
    setLoading(true);
    let order_status = status?.join(",");
    let invoice_verified = invStatus;

    dispatch(
      manageOrderList(
        {
          order_date_from: filterStoredData?.order_date_from,
          order_date_to: filterStoredData?.order_date_to,
          order_value_from: filterStoredData.order_value_from,
          order_value_to: filterStoredData.order_value_to,
          search,
          page,
          order_status,
          invoice_verified,
        },
        onSuccess,
        onError
      )
    );
  }, [
    search,
    page,
    invStatus,
    filterStoredData.order_value_from,
    filterStoredData.order_value_to,
    filterStoredData.order_date_from,
    filterStoredData.order_date_to,
    filterStoredData?.status,
  ]);

  useEffect(() => {
    if (page_no) {
      setPage(page_no);
    }
  }, [page_no]);

  const onSuccess = (data) => {
    setLoading(false);
    setManageOrderListData(data.data.data);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onError = (err) => {
    setLoading(false);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  const handleStatusInputChange = (e) => {
    const inputValue = e.target.value;
    const filtered = orderStatusOptions.filter((option) =>
      option.label.toLowerCase().includes(inputValue)
    );
    setFilteredStatusOptions(filtered);
  };

  const handleClickOrderDateOutside = (event) => {
    if (orderDateRef.current && !orderDateRef.current.contains(event.target)) {
      setOpenDate(false);
    }
  };
  const handleClickOrderValueOutside = (event) => {
    if (
      orderValueRef.current &&
      !orderValueRef.current.contains(event.target)
    ) {
      setOpenOrder(false);
    }
  };
  const handleClickOutside = (event) => {
    if (
      orderStatusRef.current &&
      !orderStatusRef.current.contains(event.target)
    ) {
      setOpenStatus(false);
    }
  };
  const handleClickInvoiceOutside = (event) => {
    if (
      invoiceStatusRef.current &&
      !invoiceStatusRef.current.contains(event.target)
    ) {
      setOpenInvStatus(false);
    }
  };

  useEffect(() => {
    if (openDate) {
      document.addEventListener("click", handleClickOrderDateOutside);
    } else {
      document.removeEventListener("click", handleClickOrderDateOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOrderDateOutside);
    };
  }, [openDate]);

  useEffect(() => {
    if (openOrder) {
      document.addEventListener("click", handleClickOrderValueOutside);
    } else {
      document.removeEventListener("click", handleClickOrderValueOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOrderValueOutside);
    };
  }, [openOrder]);

  useEffect(() => {
    if (openStatus) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [openStatus]);

  useEffect(() => {
    if (openInvStatus) {
      document.addEventListener("click", handleClickInvoiceOutside);
    } else {
      document.removeEventListener("click", handleClickInvoiceOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickInvoiceOutside);
    };
  }, [openInvStatus]);

  const queryParams = [];
  if (search) queryParams.push(`search=${search}`);
  if (filterStoredData?.invStatus)
    queryParams.push(`invStatus=${filterStoredData?.invStatus}`);
  if (filterStoredData?.order_value_from)
    queryParams.push(`order_value_from=${filterStoredData?.order_value_from}`);
  if (filterStoredData?.order_value_to)
    queryParams.push(`order_value_to=${filterStoredData?.order_value_to}`);
  if (filterStoredData?.order_date_from)
    queryParams.push(`order_date_from=${filterStoredData?.order_date_from}`);
  if (filterStoredData?.order_date_to)
    queryParams.push(`order_date_to=${filterStoredData?.order_date_to}`);
  if (filterStoredData?.status)
    queryParams.push(`status=${filterStoredData?.status}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  return (
    <>
      <div>
        <div className="table-container text-nowrap">
          <table className="main-table">
            <thead>
              <tr className="table-rows">
                <th className="table-heads " width={"4%"}>
                  #
                </th>
                <th className="table-heads " width={"10%"}>
                  Order ID
                </th>
                <th className="table-heads " width={"10%"}>
                  Customer name
                </th>
                <th
                  ref={orderDateRef}
                  className="table-heads text-nowrap "
                  width={"12%"}
                >
                  <span
                    onClick={() => {
                      setOpenDate(!openDate);
                    }}
                    className={
                      openDate
                        ? "Medium_Purple cursor_pointer"
                        : "cursor_pointer"
                    }
                  >
                    <span
                      className={
                        filterStoredData.order_date_from &&
                        filterStoredData.order_date_to
                          ? "Medium_Purple fw_700"
                          : ""
                      }
                    >
                      Order Date
                    </span>
                    {openDate ? (
                      <img src={UpArrow} className="mb-1 mx-1" />
                    ) : (
                      <img src={DownArrow} className=" mx-1" />
                    )}
                  </span>
                  {openDate ? (
                    <div className=" position-relative">
                      <div className=" position-absolute order-container">
                        <div className=" d-flex my-3">
                          <div className="mx-3">
                            <label className="fn_Nunito color_262c3d ">
                              From
                            </label>
                            <div className=" d-flex mt-1 ">
                              <div className=" d-flex align-items-center  py-1 px-3 amount_input_container ">
                                <input
                                  type="date"
                                  className="  amount_input  py-1  ms-1"
                                  placeholder="Select Date"
                                  value={order_date_from ?? ""}
                                  onfocus="(this.type = 'date')"
                                  id="date"
                                  onChange={(e) => {
                                    setOrder_date_from(e.target.value);
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="me-3">
                            <label className="fn_Nunito color_262c3d ">
                              To
                            </label>
                            <div className=" d-flex mt-1">
                              <div className=" d-flex align-items-center  py-1 px-3 amount_input_container ">
                                <input
                                  type="date"
                                  className="  amount_input  py-1  ms-1"
                                  placeholder=" Selct Date"
                                  value={order_date_to ?? ""}
                                  onChange={(e) => {
                                    setOrder_date_to(e.target.value);
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mt-2">
                          <div className="d-flex justify-content-end mx-3 gap-3">
                            <button
                              className="filter-clear-btn px-3 py-1 fs_14"
                              onClick={orderDateClear}
                            >
                              clear
                            </button>
                            <button
                              className="filter-btn px-2 py-1 fs_14"
                              type="button"
                              onClick={OrderDateSubmit}
                            >
                              Apply Filter
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </th>

                <th
                  ref={orderValueRef}
                  className="table-heads text-nowrap"
                  width={"8%"}
                >
                  <span
                    onClick={() => {
                      setOpenOrder(!openOrder);
                    }}
                    className={
                      openOrder
                        ? "Medium_Purple cursor_pointer"
                        : "cursor_pointer"
                    }
                  >
                    <span
                      className={
                        filterStoredData.order_value_from &&
                        filterStoredData.order_value_to
                          ? "Medium_Purple fw_700"
                          : ""
                      }
                    >
                      Order Value
                    </span>

                    {openOrder ? (
                      <img src={UpArrow} className="mb-1 mx-1" />
                    ) : (
                      <img src={DownArrow} className=" mx-1" />
                    )}
                  </span>

                  {openOrder ? (
                    <div className=" position-relative">
                      <div className=" position-absolute order-container">
                        <div className=" d-flex my-3">
                          <div className="mx-3">
                            <label className="fn_Nunito color_262c3d ">
                              From
                            </label>
                            <div className=" d-flex mt-1 ">
                              <div className=" d-flex align-items-center  py-1 px-3 amount_input_container ">
                                <span className="fn_Nunito fs_14 fw_700 Medium_Purple ">
                                  ₹.
                                </span>
                                <input
                                  type="number"
                                  className="  amount_input  py-1  ms-1"
                                  placeholder="Enter amount"
                                  value={order_value_from && order_value_from}
                                  onChange={(e) =>
                                    setOrder_value_from(e.target.value)
                                  }
                                />
                              </div>
                            </div>
                          </div>
                          <div className="me-3">
                            <label className="fn_Nunito color_262c3d ">
                              To
                            </label>
                            <div className=" d-flex mt-1">
                              <div className=" d-flex align-items-center  py-1 px-3 amount_input_container ">
                                <span className="fn_Nunito fs_14 fw_700 Medium_Purple ">
                                  ₹.
                                </span>
                                <input
                                  type="number"
                                  className="  amount_input  py-1  ms-1"
                                  placeholder="Enter amount"
                                  value={order_value_to && order_value_to}
                                  onChange={(e) =>
                                    setOrder_value_to(e.target.value)
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mt-2">
                          <div className="d-flex justify-content-end mx-3 gap-3">
                            <button
                              className="filter-clear-btn px-3 py-1 fs_14"
                              onClick={orderValueClear}
                            >
                              clear
                            </button>
                            <button
                              className="filter-btn px-2 py-1 fs_14"
                              type="button"
                              onClick={OrderValueSubmit}
                            >
                              Apply Filter
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </th>

                <th className="table-heads text-nowrap" width={"10%"}>
                  Distributed by
                </th>

                <th
                  ref={orderStatusRef}
                  className="table-heads text-nowrap"
                  width={"12%"}
                >
                  <span
                    className={
                      openStatus
                        ? "Medium_Purple cursor_pointer"
                        : "cursor_pointer"
                    }
                    onClick={() => {
                      setOpenStatus(!openStatus);
                    }}
                  >
                    <span
                      className={
                        filterStoredData?.status?.length > 0
                          ? "Medium_Purple fw_700"
                          : ""
                      }
                    >
                      Order Status
                    </span>

                    {openStatus ? (
                      <img src={UpArrow} className="mb-1 mx-1" alt="v" />
                    ) : (
                      <img src={DownArrow} className="mx-1" alt="v" />
                    )}
                  </span>
                  {openStatus ? (
                    <div className="position-relative">
                      <div className="city-main-container">
                        <div className="city-filter-form">
                          <div className="mx-2 my-1 pt-1">
                            <input
                              type={"text"}
                              placeholder={"search"}
                              className="filter-input w-100 py-1 px-2"
                              onChange={handleStatusInputChange}
                            />
                          </div>
                          <div
                            className="row"
                            style={{ height: "6.4rem", overflowY: "scroll" }}
                          >
                            {(filteredStatusOptions.length > 0
                              ? filteredStatusOptions
                              : orderStatusOptions
                            ).map((item, index) => (
                              <div
                                className="col-5 d-flex align-items-center ms-4"
                                key={index}
                              >
                                <div>
                                  <span className="fs_14 my-1">
                                    <input
                                      type="checkbox"
                                      id={item?.label}
                                      checked={status.find(
                                        (ex) => ex == item.value
                                      )}
                                      className="ffCheck"
                                      onClick={() => {
                                        if (status.includes(item.value)) {
                                          setStatus((prev) =>
                                            prev.filter(
                                              (ex) => ex != item.value
                                            )
                                          );
                                        } else {
                                          setStatus((prev) => [
                                            ...prev,
                                            item.value,
                                          ]);
                                        }
                                      }}
                                    />
                                  </span>
                                </div>
                                <div className="mt-2 mx-2">
                                  <label
                                    htmlFor={item?.label}
                                    className="color_747f9e fs_14 cursor_pointer"
                                  >
                                    {item.label}
                                  </label>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                        <div className="d-flex justify-content-end mx-3 gap-3">
                          <button
                            type="button"
                            className="filter-clear-btn px-3 py-1 fs_14"
                            onClick={() => {
                              setStatus([]);
                              setOpenStatus(false);
                              setFilteredStatusOptions([]);
                              orderStatusClear();
                            }}
                          >
                            clear
                          </button>
                          <button
                            className="filter-btn px-2 py-1 fs_14"
                            onClick={() => {
                              setOpenStatus(!openStatus);
                              applyStatusFilter();
                            }}
                          >
                            Apply Filter
                          </button>
                        </div>
                      </div>
                      <div></div>
                    </div>
                  ) : null}
                </th>

                <th
                  ref={invoiceStatusRef}
                  className="table-heads text-nowrap"
                  width={"10%"}
                >
                  <span
                    onClick={() => setOpenInvStatus(!openInvStatus)}
                    className={
                      openInvStatus
                        ? "Medium_Purple cursor_pointer"
                        : "cursor_pointer"
                    }
                  >
                    <span className={invStatus ? "Medium_Purple fw_700" : ""}>
                      Invoice Status
                    </span>
                    {openInvStatus ? (
                      <img src={UpArrow} className="mb-1 mx-1" />
                    ) : (
                      <img src={DownArrow} className=" mx-1" />
                    )}
                  </span>
                  {openInvStatus ? (
                    <div className=" position-relative">
                      <div className="position-absolute status-container d-flex gap-3 px-3">
                        <div className="d-flex align-items-center ">
                          <input
                            className="radio me-2"
                            type="radio"
                            id="pending"
                            name="pending"
                            value={"pending"}
                            checked={invStatus === "pending"}
                            onClick={(e) => {
                              setOpenInvStatus(!openInvStatus);
                              setInvStatus(e.target.value);
                              navigate(
                                `/manage-order?page=1${
                                  search ? `&search=${search}` : ""
                                }${
                                  filterStoredData?.order_date_from
                                    ? `&order_date_from=${filterStoredData?.order_date_from}`
                                    : ""
                                }${
                                  filterStoredData?.order_date_to
                                    ? `&order_date_to=${filterStoredData?.order_date_to}`
                                    : ""
                                }${
                                  filterStoredData?.order_value_from
                                    ? `&order_value_from=${filterStoredData?.order_value_from}`
                                    : ""
                                }${
                                  filterStoredData?.order_value_to
                                    ? `&order_value_to=${filterStoredData?.order_value_to}`
                                    : ""
                                }${
                                  filterStoredData?.status
                                    ? `&status=${filterStoredData?.status}`
                                    : ""
                                }&invStatus=pending`
                              );
                            }}
                          />
                          <label
                            htmlFor="pending"
                            className={
                              invStatus === "pending"
                                ? "color_262c3d cursor_pointer"
                                : "color_747f9e cursor_pointer"
                            }
                          >
                            Pending
                          </label>
                        </div>
                        <div className="d-flex align-items-center ">
                          <input
                            className="radio me-2"
                            type="radio"
                            id="verified"
                            name="verified"
                            value={"verified"}
                            checked={invStatus == "verified"}
                            onClick={(e) => {
                              setOpenInvStatus(!openInvStatus);
                              setInvStatus(e.target.value);
                              navigate(
                                `/manage-order?page=1${
                                  search ? `&search=${search}` : ""
                                }${
                                  filterStoredData?.order_date_from
                                    ? `&order_date_from=${filterStoredData?.order_date_from}`
                                    : ""
                                }${
                                  filterStoredData?.order_date_to
                                    ? `&order_date_to=${filterStoredData?.order_date_to}`
                                    : ""
                                }${
                                  filterStoredData?.order_value_from
                                    ? `&order_value_from=${filterStoredData?.order_value_from}`
                                    : ""
                                }${
                                  filterStoredData?.order_value_to
                                    ? `&order_value_to=${filterStoredData?.order_value_to}`
                                    : ""
                                }${
                                  filterStoredData?.status
                                    ? `&status=${filterStoredData?.status}`
                                    : ""
                                }&invStatus=verified`
                              );
                            }}
                          />
                          <label
                            htmlFor="verified"
                            className={
                              invStatus === "verified"
                                ? "color_262c3d cursor_pointer"
                                : "color_747f9e cursor_pointer"
                            }
                          >
                            Verified
                          </label>
                        </div>
                        <button
                          className="filter-btn px-2 py-0 my-2 fs_12"
                          style={{ height: "28px" }}
                          onClick={() => {
                            setInvStatus(null);
                            setOpenInvStatus(!openInvStatus);
                            navigate(
                              `/manage-order?page=1${
                                search ? `&search=${search}` : ""
                              }${
                                filterStoredData?.order_date_from
                                  ? `&order_date_from=${filterStoredData?.order_date_from}`
                                  : ""
                              }${
                                filterStoredData?.order_date_to
                                  ? `&order_date_to=${filterStoredData?.order_date_to}`
                                  : ""
                              }${
                                filterStoredData?.order_value_from
                                  ? `&order_value_from=${filterStoredData?.order_value_from}`
                                  : ""
                              }${
                                filterStoredData?.order_value_to
                                  ? `&order_value_to=${filterStoredData?.order_value_to}`
                                  : ""
                              }${
                                filterStoredData?.status
                                  ? `&status=${filterStoredData?.status}`
                                  : ""
                              }`
                            );
                          }}
                        >
                          CLEAR
                        </button>
                      </div>
                    </div>
                  ) : null}
                </th>

                <th className="table-heads text-nowrap" width={"8%"}>
                  PO Status
                </th>
                <th className="table-heads text-nowrap" width={"15%"}>
                  Reason For Rejection
                </th>
                <th className="table-heads text-nowrap" width={"10%"}>
                  Rejected By
                </th>
                <th className="table-heads text-nowrap" width={"19%"}>
                  Actions
                </th>
              </tr>
            </thead>
            <tbody style={{ position: "relative" }}>
              {loading == true ? (
                <div className="list-spinner-container">
                  <LoadingSpinnerTable />
                </div>
              ) : manageOrderListData?.orders?.length > 0 ? (
                <>
                  {manageOrderListData?.orders?.map((eachRow, index) => (
                    <ManageOrderTableData
                      key={eachRow.id}
                      data={eachRow}
                      index={index}
                      currentPage={manageOrderListData?.pagination?.currentPage}
                    />
                  ))}
                </>
              ) : (
                <tr>
                  <td
                    colSpan="1"
                    className="text-center no-data-container fs_16"
                  >
                    <span>~ No Data Found ~</span>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className={loading == true ? `loading-event` : ""}>
          {manageOrderListData?.pagination?.totalPages > 0 && (
            <NumberPagination
              setCurrentPage={setPage}
              pagination={manageOrderListData?.pagination?.currentPage}
              totalPages={manageOrderListData?.pagination?.totalPages}
              path={"/manage-order"}
              filters={`${queryString}`}
            />
          )}
        </div>
        <ErrorPopup
          show={showErrorPopup}
          title={showErrorMsg}
          handleClose={closeErrorPopup}
        />
      </div>
    </>
  );
};

export default ManageOrderTable;

export const orderStatusOptions = [
  { value: "acknowledged", label: "Acknowledged", color: "ack_status" },
  {
    value: "partially_acknowledged",
    label: "Partially Acknowledged",
    color: "color_2ad3e7 ",
  },
  { value: "fully_invoiced", label: "Fully Invoiced", color: "text_green" },
  {
    value: "partially_invoiced",
    label: "Partial Invoiced",
    color: "Medium_Purple",
  },
  { value: "pending", label: "Approval Pending", color: "Medium_Purple" },
  { value: "expired", label: "Expired", color: "text-danger" },
  { value: "cancelled", label: "Cancelled", color: "text-danger" },
  { value: "approval_failed", label: "Approval Failed", color: "text-danger" },
  { value: "approved", label: "Approved", color: "color_2ad3e7" },
  { value: "rejected", label: "Rejected", color: "text-danger" },
  { value: "hold", label: "Under Process", color: "text-warning" },
];
